export default class Logocard {
  init(root) {
    this.root = root;
    this.items = root.querySelectorAll('.logocard-item.has-back');

    this.addEvents();
  }

  addEvents() {
    this.items.forEach(item => {
      const backPanel = item.querySelector('.logocard-item-back');
      const isBackVisible = item.classList.contains('active');

      // Set aria-expanded based on whether the back of the card is visible
      item.setAttribute('aria-expanded', isBackVisible ? 'true' : 'false');
      
      // Optional: Use aria-controls to associate the card with the back panel
      item.setAttribute('aria-controls', backPanel ? backPanel.id : '');

      item.addEventListener('click', () => {
        const isExpanded = item.classList.contains('active');
        
        // Toggle card active state and aria-expanded
        if (isExpanded) {
          item.classList.remove('active');
          item.setAttribute('aria-expanded', 'false');
          if (backPanel) backPanel.hidden = true;
        } else {
          this.items.forEach(i => {
            i.classList.remove('active');
            i.setAttribute('aria-expanded', 'false');
            const iBackPanel = i.querySelector('.logocard-item-back');
            if (iBackPanel) iBackPanel.hidden = true;
          });
          item.classList.add('active');
          item.setAttribute('aria-expanded', 'true');
          if (backPanel) backPanel.hidden = false;
        }
      });

      // Support Enter and Space keys for toggling
      item.addEventListener('keydown', (event) => {
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          item.click();
        }
      });
    });
  }
}
